/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} CountryInputs */

const en_country = /** @type {(inputs: CountryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Country`)
};

const de_country = /** @type {(inputs: CountryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Land`)
};

/**
* | output |
* | --- |
* | "Country" |
*
* @param {CountryInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const country = /** @type {((inputs?: CountryInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<CountryInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_country(inputs)
	return de_country(inputs)
});